import React from 'react';

export default function Volume (props){
    
    return (
        <div className="volume-container"> 
            <div>Volume</div>
            <input className="volume" type="range" min="0" max="1" step="0.01" onChange={props.handleVolume} />
        </div>
    )
}